import { render, staticRenderFns } from "./field-total.vue?vue&type=template&id=b82b40da&scoped=true&"
import script from "./field-total.vue?vue&type=script&lang=js&"
export * from "./field-total.vue?vue&type=script&lang=js&"
import style0 from "./field-total.vue?vue&type=style&index=0&id=b82b40da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82b40da",
  null
  
)

export default component.exports